import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Attunements from "@/components/Attunements";
import LearnReiki from "@/components/LearnReiki";
import Shop from "@/components/Shop";
import About from "@/components/About";
import BlogPreview from "@/components/BlogPreview";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main data-testid="home-page">
        <Hero />
        <Services />
        <Attunements />
        <LearnReiki />
        <Shop />
        <About />
        <BlogPreview />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
